module.exports = __webpack_public_path__ + "img/feature_4.ed959547.png";